import type { GoodSolutionSchema } from "../types";
import { createDateColumn, createStringColumn } from "./columnHelpers";
import { createLinkColumn } from "./linkColumnHelper";

const namespace = "ads_good_solutions";

export const adsColumns = [
    createStringColumn<GoodSolutionSchema>({
        namespace,
        field: "metadata.SYMPTOM_CLASS_ID",
        header: "Symptom Class ID",
    }),
    createStringColumn<GoodSolutionSchema>({
        namespace,
        field: "metadata.SYMPTOM_CLASS",
        header: "Symptom Class",
    }),
    createStringColumn<GoodSolutionSchema>({
        namespace,
        field: "metadata.EquipSerialNumber",
        header: "Machine No",
    }),
    createStringColumn<GoodSolutionSchema>({
        namespace,
        field: "metadata.ProductFamily",
        header: "Product Family",
    }),
    createStringColumn<GoodSolutionSchema>({
        namespace,
        field: "metadata.Tenant",
        header: "Product Line",
    }),
    createDateColumn<GoodSolutionSchema>({
        namespace,
        field: "metadata.Date",
        header: "Date",
    }),
    createLinkColumn<GoodSolutionSchema>({
        namespace,
        field: "metadata.source",
        header: "Source",
    }),
];
